<div id="canvas">
  <div id="box_wrapper">

    <section class="ls section_padding_top_100 section_padding_bottom_100 section_full_height">
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
            <div class="with_border with_padding">
              <h1 class="text-center">
                Page Not Found
              </h1>
              <p>
                The page you are looking for is not found !
              </p>
            </div>
            <p class="divider_20 text-center">
              Go to <a [routerLink]="['/authentication/login']">Login Page</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
